import { render, staticRenderFns } from "./FacetButton.vue?vue&type=template&id=7b757c51&"
import script from "./FacetButton.vue?vue&type=script&lang=js&"
export * from "./FacetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports